import React, { useState, useEffect } from 'react';
import './NewNode.css';

const NodeModal = ({ isOpen, mode, initialData, isSaving, onClose, onSave, onToggleActive }) => {

  const [formData, setFormData] = useState({
    id:        null,
    name:      '',
    region:    '',
    latitude:  '',
    longitude: '',
    is_active: true,
  });
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    if (initialData) setFormData(initialData);
    setErrorMsg('');
  }, [initialData, isOpen]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrorMsg('');
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    if (isSaving) return;

    const latitude = Number(formData.latitude);
    const longitude = Number(formData.longitude);

    if (!formData.name?.trim() || !formData.region?.trim() || formData.latitude === '' || formData.longitude === '') {
      setErrorMsg('All node fields are required.');
      return;
    }

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      setErrorMsg('Latitude and longitude must be valid numbers.');
      return;
    }

    if (latitude < -90 || latitude > 90) {
      setErrorMsg('Latitude must be between -90 and 90.');
      return;
    }

    if (longitude < -180 || longitude > 180) {
      setErrorMsg('Longitude must be between -180 and 180.');
      return;
    }

    onSave({
      ...formData,
      name: formData.name.trim(),
      region: formData.region.trim(),
      latitude,
      longitude,
    });
  };

  return (
    <div className="modal-overlay" onClick={() => { if (!isSaving) onClose(); }}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>

        <div className="modal-header">
          <h2>{mode === 'create' ? 'Create new Node' : 'Edit Node'}</h2>
          <button className="close-btn" onClick={onClose} disabled={isSaving}>✕</button>
        </div>

        <div className="form-grid">

          {/* Node Name */}
          <div className="form-group">
            <label>Node Name</label>
            <input
              type="text"
              name="name"
              placeholder="e.g., Node 005"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          {/* Region */}
          <div className="form-group">
            <label>Region</label>
            <select name="region" value={formData.region} onChange={handleChange} required>
              <option value="">Select Region...</option>
              <option value="Northern (NEOM)">Northern (NEOM)</option>
              <option value="Shushah Island">Shushah Island</option>
              <option value="Al-Wajh & Umluj">Al-Wajh & Umluj</option>
              <option value="Thuwal & Jeddah">Thuwal & Jeddah</option>
              <option value="Southern (Jazan)">Southern (Jazan)</option>
            </select>
          </div>

          {/* Latitude — name="latitude" matches DB + formData key */}
          <div className="form-group">
            <label>Latitude</label>
            <input
              type="number"
              name="latitude"
              placeholder="e.g., 27.9"
              min="-90"
              max="90"
              step="any"
              value={formData.latitude}
              onChange={handleChange}
              required
            />
          </div>

          {/* Longitude — name="longitude" matches DB + formData key */}
          <div className="form-group">
            <label>Longitude</label>
            <input
              type="number"
              name="longitude"
              placeholder="e.g., 34.9"
              min="-180"
              max="180"
              step="any"
              value={formData.longitude}
              onChange={handleChange}
              required
            />
          </div>

        </div>

        {errorMsg && <p className="form-error">{errorMsg}</p>}

        <div className="modal-footer">
          {mode === 'create' ? (
            <>
              <button className="btn-cancel" onClick={onClose} disabled={isSaving}>Cancel</button>
              <button className="btn-submit" onClick={handleSave} disabled={isSaving}>
                {isSaving ? 'Adding & syncing...' : 'Create Node'}
              </button>
            </>
          ) : (
            <>
              <button className="btn-edit" onClick={handleSave} disabled={isSaving}>
                {isSaving ? 'Saving...' : 'Save Changes'}
              </button>
              <button
                className={`btn-deactivate ${formData.is_active ? 'btn-deactivate--off' : 'btn-deactivate--on'}`}
                onClick={() => onToggleActive(formData)}
                disabled={isSaving}
              >
                {formData.is_active ? 'Deactivate' : 'Activate'}
              </button>
            </>
          )}
        </div>

      </div>
    </div>
  );
};

export default NodeModal;
